import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Topbar from "./Topbar";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import CartDrawer from "./CartDrawer";
import SiteGate, { ShopStatusBanner } from "./SiteGate";
import RetentionPopup from "./RetentionPopup";
import { track } from "../../lib/api";
import JardinsOleBoot from "../jardins-ole/JardinsOleBoot";
import JOFooterEnhancer from "../jardins-ole/JOFooterEnhancer";
import JOShopHero from "../jardins-ole/JOShopHero";

export default function PublicLayout() {
  const loc = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("pageview");
  }, [loc.pathname]);

  const isShop = loc.pathname.startsWith("/shop") || loc.pathname.startsWith("/account");

  return (
    <SiteGate>
      <JardinsOleBoot>
        <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]">
          <Topbar />
          <Header />
          {isShop && <ShopStatusBanner />}
          <JOShopHero />
          <main className="flex-1">
            <Outlet />
          </main>
          <JOFooterEnhancer />
          <Footer />
          <FloatingActions />
          <CartDrawer />
          <RetentionPopup />
        </div>
      </JardinsOleBoot>
    </SiteGate>
  );
}
